import { defineStore } from "pinia";

export const usePaginationStore = defineStore("pagination", {
  state: () => ({
    pages: {},
  }),

  actions: {
    setPage(key, page) {
      this.pages[key] = page;
    },

    getPage(key) {
      return this.pages[key] || 1;
    },

    clearPage(key) {
      delete this.pages[key];
    },
  },
});
